import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

import styles from './ForwardingCallHistory.module.sass'

const CallHistoryRow = (props) => {
	const { call } = props

	return (
		<HStack className={styles['call-row']}>
			<Icon
				className={`${styles['call-icon']} ${
					call?.status ? styles[`--${call.status}`] : ''
				}`}
				name={call?.icon}
			/>
			<small>
				<strong>{call?.date?.shortDateFormat}, </strong>
				{call?.date?.shortTimeFormat}h
			</small>
		</HStack>
	)
}

export const ForwardingCallHistory = (props) => {
	const { callHistory } = props
	const { i18n } = useGlobal()
	return (
		<fieldset>
			<VStack className={styles['call-history-root']}>
				<h4>{i18n`Call history`}</h4>
				<VStack className={styles['history-container']}>
					{callHistory.map((item, index) => (
						<CallHistoryRow call={item} key={index} />
					))}
				</VStack>
			</VStack>
		</fieldset>
	)
}
